// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "passengers-krvbC";
var _4 = "passenger-1ZVbH";
export { _1 as "__esModule", _2 as "mobile", _3 as "passengers", _4 as "passenger" }
export default { "__esModule": _1, "mobile": _2, "passengers": _3, "passenger": _4 }
